// Navigation utility for React Router v6 compatibility with Redux class components
let navigationRef = null;

export const setNavigationRef = (navigate) => {
  navigationRef = navigate;
};

export const navigate = (to, options = {}) => {
  if (navigationRef) {
    navigationRef(to, options);
  } else {
    console.error('Navigation ref not set. Make sure NavigationSetter is rendered.');
  }
};

export const goBack = () => {
  if (navigationRef) {
    navigationRef(-1);
  }
};

export const goForward = () => {
  if (navigationRef) {
    navigationRef(1);
  }
};

// Redux action creator for navigation (to maintain compatibility with existing code)
export const push = (path) => {
  return (dispatch) => {
    navigate(path);
  };
};

export const go = (delta) => {
  return (dispatch) => {
    if (navigationRef) {
      navigationRef(delta);
    }
  };
};
